import { useDemoPath, DemoPath } from '@/contexts/DemoPathContext';
import { useDemoMode } from '@/contexts/DemoModeContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Stethoscope, Building2, Shield } from 'lucide-react';

const PATH_OPTIONS: { value: DemoPath; label: string; icon: React.ReactNode }[] = [
  { value: 'surgeon', label: 'Surgeon', icon: <Stethoscope className="w-3.5 h-3.5" /> },
  { value: 'admin', label: 'Hospital Admin', icon: <Building2 className="w-3.5 h-3.5" /> },
  { value: 'compliance', label: 'Compliance', icon: <Shield className="w-3.5 h-3.5" /> },
];

export function DemoPathToggle() {
  const { isDemoMode } = useDemoMode();
  const { demoPath, setDemoPath } = useDemoPath();

  // Only render in demo mode
  if (!isDemoMode) {
    return null;
  }

  const currentOption = PATH_OPTIONS.find(opt => opt.value === demoPath);

  return (
    <div className="flex items-center gap-2 px-2 py-1 rounded-lg border border-warning/30 bg-warning/5">
      <span className="text-xs text-warning font-medium whitespace-nowrap">Demo Path:</span>
      <Select value={demoPath} onValueChange={(value) => setDemoPath(value as DemoPath)}>
        <SelectTrigger className="h-7 w-[130px] text-xs border-warning/30 bg-transparent focus:ring-warning/50">
          <div className="flex items-center gap-1.5">
            {currentOption?.icon}
            <SelectValue />
          </div>
        </SelectTrigger>
        <SelectContent>
          {PATH_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value} className="text-xs">
              <div className="flex items-center gap-2">
                {option.icon}
                <span>{option.label}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
